import styled from "styled-components";

export const NewsContainer = styled.div`
    width: min(92%, 1280px);
    margin: 100px auto 0;

    a {
        text-decoration: none;
    }

    @media (max-width: 600px) {
        margin-top: 70px;
    }
`;

export const NewsTitle = styled.p`
    text-align: center;
    font-size: clamp(28px, 4vw, 44px);
    font-weight: 800;
    color: var(--color-primary);
    letter-spacing: -0.5px;
    margin: 0 0 36px;
`;

export const NewsBlock = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 24px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 500px) {
        grid-template-columns: 1fr;
        gap: 24px;
    }
`;
